export const LEGACY_DAILY_CELL_HEIGHT_DEFAULT = 56;
export const LEGACY_DAILY_CELL_HEIGHT_MIN = 56;
export const LEGACY_DAILY_CELL_HEIGHT_MAX = 120;
export const LEGACY_DAILY_CELL_HEIGHT_STEP = 16;
export const LEGACY_DAILY_COACH_PAGE_SIZE = 8;

export const getInitialLegacyDailyCellHeight = (savedValue: string | null) => {
    if (!savedValue) return LEGACY_DAILY_CELL_HEIGHT_DEFAULT;

    const parsed = Number(savedValue);
    return Number.isFinite(parsed) && parsed >= LEGACY_DAILY_CELL_HEIGHT_MIN && parsed <= LEGACY_DAILY_CELL_HEIGHT_MAX
        ? parsed
        : LEGACY_DAILY_CELL_HEIGHT_DEFAULT;
};

export const getLegacyDailyCoachPageCount = (coachCount: number) =>
    Math.ceil(Math.max(0, coachCount) / LEGACY_DAILY_COACH_PAGE_SIZE);

export const clampLegacyDailyCoachPage = (page: number, pageCount: number) => {
    if (pageCount <= 0) return 1;
    return Math.min(Math.max(1, page), pageCount);
};
